import chartOptionsData from '../utils/chartOptionsData.js'
import year from '../../../utils/year.js'
import { map } from '../../../api/api-endpoints.js'
import url from '../../../utils/url.js'
import {analytic} from '../../../api/api-endpoints'
import {Burial, Formed, Neutralization, Processing, Storage, Utilization, Located, WasteGenerators, Regions} from "../../../config/config";
import {PERIODS} from '../utils/types'
import region from "../../../utils/region.js"
import {SVERD} from "../../../config/region"

// TODO: убрать после показа 2016
const FieldsModel = () => ({
  dynamicType: null,
  garbageType: Formed,
  garbageYear: (region.getCurrentRegion() === SVERD ? 2016 : year.getCurrentYear()),
  garbageVolumeYear: (region.getCurrentRegion() === SVERD ? 2016 : year.getCurrentYear()),
  garbageProductionYear: (region.getCurrentRegion() === SVERD ? 2016 : year.getCurrentYear()),
  garbageOutputYear: (region.getCurrentRegion() === SVERD ? 2016 : year.getCurrentYear()),
  dynamicTypeTmpName: null,
  dynamicTypePeriod: '',
  dynamic: {
    viewMode: WasteGenerators
  },
  garbage: {
    viewMode: WasteGenerators
  },
  garbageHandlingDynamic: {
    viewMode: WasteGenerators
  },
  garbageProduction: {
    viewMode: WasteGenerators
  },
  garbageVolume: {
    viewMode: WasteGenerators
  },
  msn: {
    viewMode: WasteGenerators
  },
  msnContainer: {
    viewMode: WasteGenerators
  },
  garbageOutput: {
    viewMode: Regions
  }
})

export default {
  data () {
    return {
      yearsOptions: [],
      chartLoading: false,
      chartError: null,
      fields: new FieldsModel(),
      chartVolumeGarbageSeries: [],
      chartMSNSeries: [],
      chartMSNContainerSeries: [],
      chartCountGarbageSeries: [],
      chartCountGarbageOptions: {},
      chartProductionGarbageSeries: [],
      chartProductionGarbageOptions: {},
      chartDynamicSeries: [],
      chartDynamicOptions: {},
      chartDynamicTypeOptions: [],
      chartGarbageHandlingDynamicSeries: [],
      chartGarbageHandlingDynamicOptions: {},
      chartGarbageOutputSeries: [],
    }
  },
  watch: {
    'fields': {
      handler: function () {
        this.saveStateInRoute()
      },
      deep: true
    },
  },
  created () {
    this.$store.dispatch('updateUrlEndpoint',{ endpoint: this.getYearUrl(),fromCache: true})
      .then(r=>{
        this.yearsOptions = [];
        r.data.year.forEach(i=>{
          this.yearsOptions.push({id: i.year, name: i.year})
        })
      }).catch(e=>{
        console.log(e)
      })
    this.setFieldsFromRoute()
  },
  title: function () {
    if (this.$route && this.$route.params.chartId) {
      return this.documentTitle
    }
    return false
  },
  computed: {
    getCurrentChartOptions () {
      return this.getChartOptions(this.$route.params.chartId) || {}
    },
    documentTitle () {
      return this.getCurrentChartOptions.documentTitle
    },
    dynamicTypePeriodOptions () {
      return PERIODS
    },
    chartRedirectParams () {
      let route = url.getRoute(this.$route)
      const setFields = JSON.stringify(this.fields)
      return {
        name: 'analytic.chart',
        query: {
          setFields: setFields,
          prevRoute: JSON.stringify(route)
        }
      }
    },
    chartGarbageOutputOptions() {
      return chartOptionsData.garbageOutput.options
    },
    chartMSNContainerOptions () {
      return chartOptionsData.msnContainer.options
    },
    chartVolumeGarbageOptions () {
      return chartOptionsData.garbageVolume.options
    },
    chartMSNOptions () {
      return chartOptionsData.msn.options
    },
    chartYearOptions () {
      return this.yearsOptions;
    },
    chartViewModeOptions(){
      return [
        {id: Regions, name: 'по районам'},
        {id: WasteGenerators, name: 'по объектам'}
      ]
    }
  },
  methods: {
    getYearUrl(){
      return map.yearFuture()
    },
    // TODO: create batch server responser
    fetchChartData () {
      this.chartLoading = true
      const endpoint = this.buildEndpoint()
      this.chartError = null
      return this.$store.dispatch('updateUrlEndpoint', {
        endpoint,
        params: {
          disableGlobalError: true
        }
      }).then(r => {
        requestAnimationFrame(() => {
        })
        return r
      }).catch(e => {
        this.chartError = e
        return e
      }).finally(() => {
        this.chartLoading = false
      })
    },
    getDiffed (asJson = true) {
      let defaultFields = new FieldsModel()
      let diffed = {}
      for (let key in this.fields) {
        // skip tmp and not changed from default values
        if (defaultFields[key] !== this.fields[key]) {
          diffed[key] = this.fields[key]
        }
      }
      return asJson ? JSON.stringify(diffed) : diffed
    },
    saveStateInRoute () {
      let route = url.getRoute(this.$route)
      route.query.setFields = this.getDiffed()
      if (route.query.prevRoute) {
        let prevRoute = JSON.parse(route.query.prevRoute)
        prevRoute.query.setFields = route.query.setFields
        route.query.prevRoute = JSON.stringify(prevRoute)
      }
      this.$router.replace(route)
    },
    setFieldsFromRoute () {
      let route = url.getRoute(this.$route)
      if (route.query.setFields) {
        let fields = JSON.parse(route.query.setFields)
        for (let key in fields) {
          this.fields[key] = fields[key]
        }
      }
    },
    getChartSeries (type) {
      return chartOptionsData[type].series
    },
    getChartOptions (type) {
      return chartOptionsData[type].options
    },
    transform (response) {
      let data = []
      if (response && response.data && response.data.data) {
        response.data.data.forEach(v => {
          data.push({
            name: v.name,
            y: +v.y
          })
        })
      }
      return [{data}]
    },
    getEndpoint () {
      return analytic.chart
    }
  },
  asyncData () {
    return Promise.resolve(1)
  },

}
